<template lang="pug">
  .report-options.body-1(v-show="show")
    h4 Report Options
    .signatures
      CustomRadio(
        :model-value="false"
        :value="signatures"
        @input="$emit('update:signatures', $event)"
      )  Without Signatures
      br
      CustomRadio(
        :model-value="true"
        :value="signatures"
        @input="$emit('update:signatures', $event)"
      )  With Signatures
    h4.mt-3 Date Range
    .date-range
      p Date range has a maximum of 90 days.
      CustomCheckbox(
        :value="specifyTime"
        @input="$emit('update:specifyTime', $event)"
      )  Specify Time
      .row.mt-2
        div(:class="{'col-md-4': specifyTime, 'col-md-2': !specifyTime}")
          | From
        div(:class="{'col-md-4': specifyTime, 'col-md-2': !specifyTime}")
          | To
      .row
        div(:class="{'col-md-4': specifyTime, 'col-md-2': !specifyTime}")
          .input-group
            Datepicker.date(:value="fromDate"
                            @input="$emit('update:fromDate', $event)"
                            :input-class="{'form-control': true, 'is-invalid': !valid}")
            input.hour.form-control(:value="fromHour"
                                    @input="$emit('update:fromHour', $event.target.value)"
                                    v-if="specifyTime"
                                    @focusout="fixTimeFormat('fromHour')")
            span.ml-1.colon(v-if="specifyTime") :
            input.minute.form-control(:value="fromMinute"
                                      @input="$emit('update:fromMinute', $event.target.value)"
                                      v-if="specifyTime"
                                      @focusout="fixTimeFormat('fromMinute')")
            CustomRadio.mr-2(model-value="AM"
                              :value="fromAmPm"
                              @input="$emit('update:fromAmPm', $event)"
                              v-if="specifyTime")  AM
            CustomRadio(model-value="PM"
                        :value="fromAmPm"
                        @input="$emit('update:fromAmPm', $event)"
                        v-if="specifyTime")  PM
        div(:class="{'col-md-4': specifyTime, 'col-md-2': !specifyTime}")
          .input-group
            Datepicker.date(
              :value="toDate"
              @input="$emit('update:toDate', $event)"
              :input-class="{'form-control': true, 'is-invalid': !valid}")
            input.hour.form-control(:value="toHour"
                                    @input="$emit('update:toHour', $event.target.value)"
                                    v-if="specifyTime"
                                    @focusout="fixTimeFormat('toHour')")
            span.ml-1.colon(v-if="specifyTime") :
            input.minute.form-control(:value="toMinute"
                                      @input="$emit('update:toMinute', $event.target.value)"
                                      v-if="specifyTime"
                                      @focusout="fixTimeFormat('toMinute')")
            CustomRadio.mr-2(model-value="AM"
                              :value="toAmPm"
                              @input="$emit('update:toAmPm', $event)"
                              v-if="specifyTime")  AM
            CustomRadio(model-value="PM"
                        :value="toAmPm"
                        @input="$emit('update:toAmPm', $event)"
                        v-if="specifyTime")  PM
      .row.mt-2
        .col
          em Note: Store time zone is used for search.

</template>

<script>
import CustomCheckbox from './CustomCheckbox'
import CustomRadio from './CustomRadio'
import Datepicker from './Datepicker'
import { loadForm } from '@/lib/formstore'
import { format, subDays, parse, differenceInCalendarDays } from 'date-fns/esm'

export default {
  name: 'StoreActivityReportOptions',
  data: function() {
    return {}
  },
  computed: {
    valid() {
      let f = parse(this.fromDate, 'MM/dd/yyyy', new Date())
      let t = parse(this.toDate, 'MM/dd/yyyy', new Date())
      let diff = Math.abs(differenceInCalendarDays(t, f))
      if (diff > 90 && this.formSubmitted) {
        this.$emit('update:valid', false)
        return false
      } else {
        this.$emit('update:valid', true)
        return true
      }
    },
  },
  methods: {
    fixTimeFormat(item) {
      const t = this[item]
      if (t.length === 1) this.$emit(`update:${item}`, '0' + this[item])
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    formSubmitted: {
      type: Boolean,
      default: false,
    },
    fromDate: { type: String, default: '' },
    fromHour: { type: String, default: '' },
    fromMinute: { type: String, default: '' },
    fromAmPm: { type: String, default: '' },
    toDate: { type: String, default: '' },
    toHour: { type: String, default: '' },
    toMinute: { type: String, default: '' },
    toAmPm: { type: String, default: '' },
    specifyTime: { type: Boolean, default: false },
    signatures: { type: Boolean, default: false },
  },
  components: {
    CustomRadio,
    CustomCheckbox,
    Datepicker,
  },
}
</script>

<style lang="scss" scoped>
.report-options {
  border: 1px solid #e6e6e6;
  padding: 1rem;

  .signatures {
    padding-bottom: 1rem;
    border-bottom: 1px solid #e6e6e6;
  }

  .input-group {
    .form-control {
      padding: 0.2rem;
    }
    .form-control:not(:first-child) {
      margin-left: 0.4rem;
    }

    .hour,
    .minute {
      max-width: 2rem;
    }

    .minute {
      margin-right: 0.5rem;
    }

    .date {
      max-width: 7rem;
    }

    .colon {
      position: relative;
      top: 5px;
    }
  }
}
</style>
